import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'tanok';
import { t } from 'c-3po';

import { toJS } from '../../../helpers/ImmutableToJS';

import { Config } from './../../../../core/config';
import * as a from './../../../../libs/actions';

import { Button } from '../../../ui/button';
import { Checkbox } from '../../../ui/checkbox';
import { Input } from '../../../ui/input';

import { Social } from '../../../components/social';

// styles
import css from './authBody.sss';


class RegisterView extends React.Component {

    static propTypes = {
        registerFields: PropTypes.object,
        fieldsErrors: PropTypes.object,
        isLoadingData: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.state = { overlayType: null };

        const termsContainer = document.getElementById('terms-of-use');
        const privacyContainer = document.getElementById('privacy-policy');

        this.agreementTextData = {
            termsOfUseHTML: (termsContainer && termsContainer.innerHTML) || '',
            privacyPolicyHTML: (privacyContainer && privacyContainer.innerHTML) || '',
        };

        this.formId = 'chat-reg-form-port';
    }

    componentDidMount() {
        this.props.send(a.EVENT_REGISTER_REG_TRACKER,
            { node: document.getElementById(this.formId) });
    }

    handleUserNameChange = ({ target }) => {
        const { value } = target;
        this.props.send(a.EVENT_REGISTER_USERNAME_CHANGE, { value });
    }

    handleEmailChange = ({ target }) => {
        const { value } = target;
        this.props.send(a.EVENT_REGISTER_EMAIL_CHANGE, { value });
    }

    handlePasswordChange = ({ target }) => {
        const { value } = target;
        this.props.send(a.EVENT_REGISTER_PASSWORD_CHANGE, { value });
    }

    toggleRegAgreement = () => {
        this.props.send(a.EVENT_REGISTER_AGREEMENT_TOGGLE);
    }

    handleSubmitRegister = (ev) => {
        ev.preventDefault();
        const { registerFields } = this.props;
        if (!registerFields.agreement) return false;

        this.props.send(a.TR_REGISTER_USER);
        return void 2 / 0;
    }

    render() {
        const {
            PERSONAL_DATA_PROCESSING_URL,
            NEW_RUSSIAN_POLICY_LAW,
            PORTAL_DOMAIN,
            CURRENT_DOMAIN
        } = Config.data.appState;

        const { IS_RU_PROM } = Config.data.appState;

        const PRIVACY_POLICY_URL = `${PORTAL_DOMAIN}/privacy-policy`;
        const TERMS_OF_USE_URL = `${PORTAL_DOMAIN}/terms-of-use`;

        const { registerFields, fieldsErrors, isLoadingData, sendAnaliticsAction } = this.props;

        return (
            <div className={css.root}>
                <div className={css.container}>
                    <div className={css.content}>
                        <Social sendAnaliticsAction={sendAnaliticsAction} />
                        <div className={css.spacer}>
                            <span className={css.spacerText}>Или через эл. почту</span>
                        </div>
                        <form
                            onSubmit={this.handleSubmitRegister}
                            data-qaid='registration_form'
                            id={this.formId}
                        >
                            <div className={css.row}>
                                <Input
                                    name='username'
                                    dataQa='name_input'
                                    placeholder={t`Как вас зовут?`}
                                    value={registerFields.userName}
                                    autoFocus
                                    maxLength='100'
                                    error={fieldsErrors.first_name}
                                    onChange={this.handleUserNameChange}
                                />
                                {fieldsErrors.first_name && (fieldsErrors.first_name.map((error) => (
                                    <div
                                        className={css.fieldError}
                                        dangerouslySetInnerHTML={{ __html: error }}
                                    />
                                )))}
                            </div>
                            <div className={css.row}>
                                <Input
                                    name='email'
                                    dataQa='email_input'
                                    placeholder={t`Введите email`}
                                    value={registerFields.email}
                                    maxLength='100'
                                    error={fieldsErrors.email}
                                    onChange={this.handleEmailChange}
                                />
                                {fieldsErrors.email && (fieldsErrors.email.map((error) => (
                                    <div
                                        className={css.fieldError}
                                        dangerouslySetInnerHTML={{ __html: error }}
                                    />
                                )))}
                            </div>
                            <div className={css.row}>
                                <Input
                                    type='password'
                                    name='password'
                                    dataQa='pwd_input'
                                    placeholder={t`Придумайте пароль`}
                                    value={registerFields.password}
                                    maxLength='100'
                                    error={fieldsErrors.password}
                                    onChange={this.handlePasswordChange}
                                />
                                {fieldsErrors.password && (fieldsErrors.password.map((error) => (
                                    <div
                                        className={css.fieldError}
                                        dangerouslySetInnerHTML={{ __html: error }}
                                    />
                                )))}
                            </div>
                            <div className={css.agreement}>
                                <Checkbox
                                    name={`chat-reg-agreement`}
                                    checked={registerFields.agreement}
                                    onChange={this.toggleRegAgreement}
                                >
                                    {NEW_RUSSIAN_POLICY_LAW && IS_RU_PROM ? (
                                        <React.Fragment>
                                            {t`Я даю согласие на обработку моих персональных данных, соглашаюсь с `}
                                            <a
                                                href={TERMS_OF_USE_URL}
                                                className={css.agreementLink}
                                                data-qaid='term_of_use_link'
                                                name='termOfUse'
                                                target='_blank'
                                                key='termOfUserRefChat'
                                            >{t`пользовательским соглашением`}</a>
                                            {t` и `}
                                            <a
                                                href={PRIVACY_POLICY_URL}
                                                className={css.agreementLink}
                                                data-qaid='privacy_policy_link'
                                                name='privacyPolicy'
                                                target='_blank'
                                                key='privacyPolicyRefChat'
                                            >{t`политикой конфиденциальности`}</a>
                                            {t`, ознакомлен с `}
                                            <a
                                                href={PERSONAL_DATA_PROCESSING_URL}
                                                className={css.agreementLink}
                                                name='personalData'
                                                target='_blank'
                                                key='personalDataRefChat'
                                            >{t`политикой`}</a>
                                            {t` в отношении обработки персональных данных`}
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                            {t`Я соглашаюсь с `}
                                            <a
                                                href={TERMS_OF_USE_URL}
                                                className={css.agreementLink}
                                                data-qaid='term_of_use_link'
                                                name='termOfUse'
                                                target='_blank'
                                                key='termOfUserRefChat'
                                            >{t`пользовательским соглашением`}</a>
                                            {t` и `}
                                            <a
                                                href={PRIVACY_POLICY_URL}
                                                className={css.agreementLink}
                                                data-qaid='privacy_policy_link'
                                                name='privacyPolicy'
                                                target='_blank'
                                                key='privacyPolicyRefChat'
                                            >{t`политикой конфиденциальности`}</a>
                                            {t` портала ${CURRENT_DOMAIN}`}
                                        </React.Fragment>
                                    )}
                                </Checkbox>
                            </div>
                            <div className={css.row}>
                                <Button
                                    type='submit'
                                    isLoading={isLoadingData.register}
                                    disabled={
                                        !registerFields.agreement || !registerFields.userName ||
                                        !registerFields.email || !registerFields.password
                                    }
                                    dataQa='submit_btn'
                                >
                                    {t`Зарегистрироваться`}
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    registerFields: state.get('registerFields'),
    fieldsErrors: state.get('fieldsErrors'),
    isLoadingData: state.get('isLoadingData'),
    locale: state.get('locale')
});

export const Register = connect(mapStateToProps)(toJS(RegisterView));
